// @ts-strict-ignore
import { ArticleLocationVO } from '@article/model/vo/article-location.vo';
import { ArticleUsageVO } from '@article/model/vo/article.vo';

export class OnRailReferenceArticleLocationVO extends ArticleLocationVO {
  public rangeOnLineArticleUsage: ArticleUsageVO;
  public rangeOnLineType: string;
  public rotationAngle: number;
  public offsetReferencesMiddlePoint: boolean = false;

  public constructor() {
    super();
  }
}
